import { makeAutoObservable } from 'mobx'
import { type IResponseRcs } from '../api/types'

export type IRcs = Rcs

export class Rcs {
  constructor(private _origin: IResponseRcs) {
    this.syncOrigin(this._origin)
    makeAutoObservable(this)
  }
  get id() {
    return this._origin.id
  }

  get name() {
    return this._origin.name
  }

  get status() {
    return this._origin.compliance_status
  }

  get description() {
    return this._origin.description
  }

  get logoName() {
    return this._origin.logo_path?.split('/').pop() || ''
  }

  get bannerName() {
    return this._origin.banner_path?.split('/').pop() || ''
  }

  get fallbackInboxId() {
    return this._origin?.fallback_inbox_id
  }

  get origin() {
    return this._origin
  }

  syncOrigin(origin: IResponseRcs) {
    this._origin = origin
  }

  updateFallbackInboxId(fallbackInboxId: number) {
    this._origin.fallback_inbox_id = fallbackInboxId
  }
}
